import React, { FC, useState } from "react";
import classes from "./EditWorkersList.module.scss";
import { Edit } from "@mui/icons-material";
import EditWorkerHeader from "./header/EditWorkerHeader";
import { Modal, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User, Worker } from "../../../types";
import EditWorkersMain from "./main/EditWorkersMain";
import { setUserToLocalStorage } from "../../../utils/functions/localStorageManager";

type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditWorkersList: FC<Props> = (props) => {
  const theme = useTheme();
  const { setIsShow } = props;
  const [open, setOpen] = useState(true);
  const [user, setUser] = useRecoilState(userState);
  const [workerList, setWorkerList] = useState<Worker[]>(
    user.initialParameters.workersForList
  );

  const handleSaveButtonClick = () => {
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          workersForList: workerList,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
    setOpen(false);
    setIsShow(false);
  };
  const handleCancelButtonClick = () => {
    setOpen(false);
    setIsShow(false);
  };

  const handleSearchButtonClick = () => {};
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: "none",
        "&:focus-visible": {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div className={classes.formContainer}>
        <EditWorkerHeader
          onSave={handleSaveButtonClick}
          onCancel={handleCancelButtonClick}
          setWorkerList={setWorkerList}
          workerList={workerList}
        />
        <EditWorkersMain
          workerList={workerList}
          setWorkerList={setWorkerList}
        />
      </div>
    </Modal>
  );
};

export default EditWorkersList;
